<script setup lang="ts">
const route = useRoute()
const { data: tag } = await useFetch(`/api/tag/${route.params.id}`, { key: `pt${route.params.id}` })
const { Settings } = useSettings()
</script>

<template>
<section>
  <Head><Title>{{ Settings.name }} - #{{ tag.name }}</Title></Head>
  <h2 class="mb-6">
    {{ $t('Tag') }} - {{ tag?.name }}
  </h2>
 <AutoPostList
 :api="`/api/tag/${tag.id}/posts`"
 />
</section>
</template>
